import React, { useState } from 'react';
import Map from '../Components/Map';
import data from '../API/data.json';
import users from '../API/users.json';
import { Base64 } from 'js-base64';
import './styles.css';
import { IFinalData } from '../utils/data-mapping';
import { Checkbox, CheckboxGroup } from '@chakra-ui/checkbox';
import { Stack, Text } from '@chakra-ui/react';
import { uniqBy } from 'lodash';

const Home = () => {
    const finalData = data as IFinalData[];
    const [isLogged, setIsLogged] = useState(false);
    const [errorMessages, setErrorMessages] = useState({ name: '', message: '' });
    const [department, setDepartment] = useState<string | undefined>(undefined);
    const [filters, setFilters] = useState<string[]>(['1', '2', '3', '4', '5']);
    // React.useEffect(() => {
    //     finalData.forEach((d) => {
    //         if (!d.zipcode) {
    //             console.info(`NO ZIPCODE ${d.id} : ==> ${d.address} ${d.city}`);
    //         }
    //         if (!d.coords) {
    //             console.info(`NO COORDS : ${d.id} : ==> ${d.address} ${d.city}`);
    //         }
    //     });
    // }, []);
    const errors = {
        uname: 'Département invalide',
        pass: 'Mot de passe invalide',
    };

    const handleSubmit = (event: any) => {
        //Prevent page reload
        event.preventDefault();

        var { uname, pass } = document.forms[0];
        // Find user login info
        const userData = users.find((user) => user.username === uname.value);
        // Compare user info
        if (userData) {
            setDepartment(userData.username);
            if (userData.passwordEncoded !== Base64.encode(pass.value)) {
                // Invalid password
                setErrorMessages({ name: 'pass', message: errors.pass });
            } else {
                setIsLogged(true);
            }
        } else {
            // Username not found
            setErrorMessages({ name: 'uname', message: errors.uname });
        }
    };

    const renderErrorMessage = (name: string) => name === errorMessages.name && <div className="error">{errorMessages.message}</div>;

    const onChangeFilters = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (filters.includes(e.target.value)) {
            const newFilters = [...filters].filter((f) => f !== e.target.value);
            setFilters(newFilters);
        } else {
            const newFilters = [...filters, e.target.value];
            setFilters(newFilters);
        }
    };

    const recomputeDataWithFilters = (data: IFinalData[]) => {
        let newData = [...data];
        if (filters.length === 5) {
            return data;
        }
        if (!filters.includes('1')) {
            newData = newData.filter((d) => d.total !== '1');
        }
        if (!filters.includes('2')) {
            newData = newData.filter((d) => d.total !== '2');
        }
        if (!filters.includes('3')) {
            newData = newData.filter((d) => d.total !== '3');
        }
        if (!filters.includes('4')) {
            newData = newData.filter((d) => d.total !== '4');
        }
        if (!filters.includes('5')) {
            newData = newData.filter((d) => parseInt(d.total) < 5);
        }
        return newData;
    };

    if (!isLogged) {
        return (
            <>
                <Map data={[]}></Map>
                <div className="login">
                    <div className="form">
                        <form onSubmit={handleSubmit}>
                            <div className="input-container">
                                <label>Département </label>
                                <input placeholder="Requis" type="text" name="uname" required />
                                {renderErrorMessage('uname')}
                            </div>
                            <div className="input-container">
                                <label>Mot de passe </label>
                                <input placeholder="Requis" type="password" name="pass" required />
                                {renderErrorMessage('pass')}
                            </div>
                            <div className="button-container">
                                <input type="submit" value={'Se connecter'} />
                            </div>
                        </form>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div style={{ position: 'relative', backgroundColor: 'red', width: '100%', height: '100%' }}>
            <Map
                data={
                    department === 'admin'
                        ? recomputeDataWithFilters(finalData).filter((d) => d.zipcode && d.coords)
                        : recomputeDataWithFilters(finalData).filter((d) => d.zipcode && d.coords && department && d.zipcode.startsWith(department))
                }
                department={department}
            />
            <div id="checkboxes" style={{ position: 'absolute', width: 200, height: 500, top: 100, right: 0, zIndex: 10000 }}>
                <Text fontSize="lg">Filtres appliqués</Text>
                <CheckboxGroup colorScheme="green" value={filters} defaultValue={['1', '2', '3', '4', '5']}>
                    <Stack spacing={[5, 5]} direction={['column']} marginBottom={'3'}>
                        <Checkbox onChange={onChangeFilters} value="1">
                            1 logement
                        </Checkbox>
                        <Checkbox onChange={onChangeFilters} value="2">
                            2 logements
                        </Checkbox>
                        <Checkbox onChange={onChangeFilters} value="3">
                            3 logements
                        </Checkbox>
                        <Checkbox onChange={onChangeFilters} value="4">
                            4 logements
                        </Checkbox>
                        <Checkbox onChange={onChangeFilters} value="5">
                            5 + logements
                        </Checkbox>
                    </Stack>
                </CheckboxGroup>
            </div>
            {department !== 'admin' && (
                <div id="legend" style={{ position: 'absolute', width: 600, height: 500, top: 100, left: 20, zIndex: 10000 }}>
                    <Text fontSize="lg">Légende</Text>
                    {uniqBy(
                        recomputeDataWithFilters(finalData).filter((d) => d.zipcode && d.coords && department && d.zipcode.startsWith(department)),
                        (e) => e.name
                    ).map((d) => {
                        return (
                            <Stack key={d.id} direction="row" marginBottom={'5'}>
                                <div style={{ width: 30, height: 10, backgroundColor: `${d.color}`, marginRight: 20 }} />
                                <p>{d.name}</p>
                            </Stack>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default Home;
